import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyL, DisplayXXL } from '#src/atoms/typography/index.tsx';
import type { Pictures } from '#src/components/landing/types.ts';
import { useConnectionContext } from '#src/contexts/connection/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const Root = styled(Vertical)`
  padding: calc(12 * var(--unit)) 0;
  background-image: var(--backupField);
  background-image: var(--field);
  text-align: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
const Header = styled(Vertical)`
  max-width: 392px;
`;

type CompeteAssets = {
  field: Pictures;
};
type Props = {
  assets: CompeteAssets;
  title: ReactNode;
  description: ReactNode;
  promotion?: ReactNode;
  img?: ReactNode;
};
export const Compete = ({
  assets,
  title,
  description,
  promotion,
  img,
}: Props) => {
  const { signUp } = useConnectionContext();
  return (
    <Root
      gap={8}
      center
      style={
        {
          '--backupField': `url(${assets.field.pictureUrl})`,
          '--field': `image-set(url(${assets.field.avif}) type('image/avif'), url(${assets.field.pictureUrl}) type('image/webp'))`,
        } as CSSProperties
      }
    >
      <Header gap={3} center>
        <Vertical gap={2}>
          <DisplayXXL>{title}</DisplayXXL>
          <BodyL>{description}</BodyL>
        </Vertical>
        <Button color="secondary" size="medium" onClick={signUp}>
          <FormattedMessage {...glossary.playNow} />
        </Button>
      </Header>
      {img}
      {promotion}
    </Root>
  );
};
